import { Badge } from '../ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { ArrowUpRight } from 'lucide-react';

export const AdminTransactionsTab = ({ transactions }) => (
  <Card>
    <CardHeader>
      <CardTitle>Transactions d'énergie ({transactions.length})</CardTitle>
    </CardHeader>
    <CardContent>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b">
              <th className="text-left py-3 px-4 font-medium text-muted-foreground">Date</th>
              <th className="text-left py-3 px-4 font-medium text-muted-foreground">Producteur &rarr; Consommateur</th>
              <th className="text-right py-3 px-4 font-medium text-muted-foreground">Énergie</th>
              <th className="text-right py-3 px-4 font-medium text-muted-foreground">Montant</th>
              <th className="text-right py-3 px-4 font-medium text-muted-foreground">Commission</th>
            </tr>
          </thead>
          <tbody>
            {transactions.map((tx, i) => (
              <tr key={i} className="border-b hover:bg-muted/50">
                <td className="py-3 px-4 text-sm text-muted-foreground">
                  {tx.timestamp ? new Date(tx.timestamp).toLocaleDateString('fr-FR') : '-'}
                </td>
                <td className="py-3 px-4">
                  <div className="flex items-center gap-2">
                    <span className="text-sm">{tx.producer_name || 'Producteur'}</span>
                    <ArrowUpRight className="w-4 h-4 text-muted-foreground" />
                    <span className="text-sm">{tx.consumer_name || 'Consommateur'}</span>
                  </div>
                </td>
                <td className="py-3 px-4 text-right font-medium">{tx.energy_kwh} kWh</td>
                <td className="py-3 px-4 text-right font-medium">{tx.total_amount?.toFixed(2)}€</td>
                <td className="py-3 px-4 text-right text-green-600 font-medium">+{(tx.total_amount * 0.1)?.toFixed(2)}€</td>
              </tr>
            ))}
            {transactions.length === 0 && (
              <tr><td colSpan={5} className="py-8 text-center text-muted-foreground">Aucune transaction</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </CardContent>
  </Card>
);
